module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAT1JREFUSEvtlTFKxEAUhr//BnoAUTyBtja6nsATqLUIupVio91Wgjcw3sADCEYsbHdv4BEs7Z78koEYszEZWLDYByEkmfm/mZd/3hMLDlk/IlaAa2ArkzeTdN42NwHugLNMcU97kbTXBSiB3SWgb4oeqp/9CDivTp/v78BGJWJTTIGj6nnQP1itBC1gYYsdAMc10A3g6zkHMAa8egum1XvlBvldUV0fuYAcMw1K0RLwIwOpVPybkzwD7J5mTP8qdr12IEkRYauu93CCnVUOSlEFiB7iHlJKGuUC0gHsYmUDXoEnYBM47CBMJF0N2gGwDewDt8ApcAGszYHsSHprAsaS3N06IyIugcmcQZ/AiaR7f2+2TFdQF7qusE1TSU/VtD5+ZPekF/Wm76bd2ldbaIWkIiJ+Aeyc+vhvwCLjCzpRohmUXuzYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left/cateringtoday.png
// module id = 7K8l
// module chunks = 1